var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-select__item"},[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.item.text))]),(_vm.storeInfo)?_c('span',{staticClass:"text-caption text--secondary"},[_vm._v(" ("+_vm._s(_vm.storeInfo)+") ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }